import React from 'react';
import { Form } from 'react-final-form';

import { TextFieldPill } from '../../01_atoms/FormElements';
import Button from '../../01_atoms/Button';

import { PTButtonFieldForm, PTButtonFieldFormDefaults } from './prop-types';
import { currencySymbolPath } from '../../../utils/currency';
import { composeParsers } from '../../../utils/formFieldParsers';
import { composeValidators } from '../../../utils/formFieldValidators';

// TODO: use CSS modules.
class ButtonFieldForm extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      isLoading: false,
    };
  }

  componentDidUpdate() {
    const { selected } = this.props;
    const { current: elementForm } = this.formRef;

    // When a user clicks on "Other" money handle item, selected is switched to it,
    // and elementForm becomes linked to the form element inside that money handle.
    // We use this reference to auto-focus on the amount field when a user clicks
    // anywhere on "Other" money handle item.
    if (selected && elementForm) {
      // Focus input field.
      elementForm.getElementsByTagName('input')[0].focus();
    }
  }

  onSubmit = ({ value, currency }) => {
    const { onSubmit, disableLoadingFeature, position } = this.props;

    // TODO: consider reworking in an simpler solution.
    // setState in callback generates warning in real world application:
    // Can't perform a React state update on an unmounted component.
    if (disableLoadingFeature) {
      return onSubmit({ value, currency, position });
    }

    this.setState((state) => ({ ...state, isLoading: true }));
    return onSubmit({ value, currency, position }).then(() => {
      this.setState((state) => ({ ...state, isLoading: false }));
    });
  };

  render() {
    const { currency, form, isDisabled, onSelectOption, selected } = this.props;
    const { isLoading } = this.state;

    return (
      <div
        className={`d-flex flex-column button-field button-field-form ${
          selected ? 'selected' : ''
        } ${isLoading ? 'loading' : ''}`}
        onClick={() => {
          onSelectOption();
        }}
        onKeyPress={() => {
          onSelectOption();
        }}
      >
        {form.inputTitle && <div className="header-two rockitt">{form.inputTitle}</div>}

        <Form
          onSubmit={this.onSubmit}
          initialValues={{ currency }}
          subscription={{ submitting: true, valid: true }}
          render={({ handleSubmit, submitting, valid }) => (
            <form className="d-flex flex-column" onSubmit={handleSubmit} ref={this.formRef}>
              <TextFieldPill
                name="value"
                placeholder={form.placeholder}
                color="white"
                icon={currencySymbolPath[currency]}
                parse={form.inputParsers && composeParsers(...form.inputParsers)}
                validate={form.inputValidators && composeValidators(...form.inputValidators)}
                label={form.placeholder}
                // Enable numeric keyboard for mobile devices.
                inputMode="numeric"
                pattern="[0-9]+"
                infoOnPatternNotMatched="Please use numbers only"
                isRequired={form.isRequired}
              />

              <Button
                className="mt-auto"
                type="white-pink"
                isLoading={submitting}
                isDisabled={isDisabled || !valid}
                isOutlined
                isBlock
              >
                {form.buttonLabel}
              </Button>
            </form>
          )}
        />
      </div>
    );
  }
}

ButtonFieldForm.propTypes = PTButtonFieldForm.isRequired;
ButtonFieldForm.defaultProps = PTButtonFieldFormDefaults;

export default ButtonFieldForm;
